import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamFeaturesComponent } from './team-features.component';
import { ListModule } from '../list/list.module';
import { IconModule } from '../icon/icon.module';

@NgModule({
  imports: [CommonModule, ListModule, IconModule],
  declarations: [TeamFeaturesComponent],
  exports: [TeamFeaturesComponent],
})
export class TeamFeaturesModule {}
